<template>
  <v-overlay scroll-strategy="none">
    <slot />
  </v-overlay>
</template>

<style scoped>
.v-overlay {
  align-items: center;
  justify-content: center;
}
</style>